import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Echo from "laravel-echo";

import { useLocation } from "react-router-dom";
import { getUser, hasPermission, logout } from "../../services/auth";
import Button from "../Button";
import api from "../../services/api";

export const SidebarItem = ({item, user}) => {
    const [active, setActive] = useState(false);

    const location = useLocation();
    const pathname = location.pathname;
    
    useEffect(() => {
        if(pathname == item.to){
            setActive(true);
        }
        if(item.subitems){
            item.subitems.map(subitem => {
                if(subitem.to === pathname){
                    setActive(true);
                }
            });
        }
    }, [location]);

    return (
        <li className={active ? 'active' : ''}>
            {!item.subitems && 
                <Link to={item.to}>
                    <img src={ require(`../../assets/images/svgs/${item.svg}.svg`)} alt={item.name} />
                    {item.name}
                    {item?.alert !== undefined && item?.alert !== 0 &&
                        <span className="alert">{item.alert}</span>
                    }
                </Link>
            }
            {item.subitems && 
                <a onClick={() => setActive(prev => !prev)}>
                    <img src={ require(`../../assets/images/svgs/${item.svg}.svg`)} alt={item.name} />
                    {item.name}
                    {item.subitems &&
                        <img src={ require(`../../assets/images/svgs/arrow.svg`).default} className="arrow" alt="alterar" />
                    }
                </a>
            }
            
            {item.subitems &&
                <ul>
                    {item.subitems.map((subitem, index) => {
                        if(subitem.show){
                            return (
                                <SidebarSubitem subitem={subitem} key={index} />
                            );
                        }   
                    })}
                </ul>
            }
        </li>
    );
}

export const SidebarSubitem = ({subitem}) => {
    const [active, setActive] = useState(false);
    const [quoteCount, setQuoteCount] = useState(0);

    const location = useLocation();
    
    useEffect(() => {
        if(location.pathname === subitem.to){
            setActive(true);
        }
    }, []);

    return (
        <li className={active ? 'active' : ''}>
            <Link to={subitem.to}>
                <span className="dot"></span>
                {subitem.name}
            </Link>
        </li>
    );
}


export const Sidebar = () => {
    const user = getUser();
    const navigate = useNavigate();
    const [quoteCount, setQuoteCount] = useState(0);
    const [items, setItems] = useState([]);

    // useEffect(() => {
    //     getQuotes();
    //     const intervalId = setInterval(() => {
    //         getQuotes();
    //     }, 5000);

    //     return () => clearInterval(intervalId);
    // }, []);

    useEffect(() => {
        getItems();
    }, [,quoteCount]);

    const getQuotes = () => {
        api.get(`/budget/count?filters[1][related][status.name][equal]=Aguardando orçamento`).then(res => {
            setQuoteCount(res.data.count);
        });
    }

    const signOut = () => {
        logout();
        navigate(`/login`);
    }

    const getItems = () => {
        const base = [
            {
                name: 'Dashboard',
                svg: 'dashboard',
                to: '/dashboard',
                show: hasPermission(['view_related_dashboard', 'view_unrelated_dashboard']),
            },
            {
                name: 'Produtos',
                svg: 'product',
                show: hasPermission(['view_product', 'view_color', 'view_category', 'view_tag', 'view_customization']),
                subitems: [
                    { 
                        name: 'Produtos', 
                        to: '/product/list',
                        show: hasPermission('view_product')
                    },
                    { 
                        name: 'Cores', 
                        to: '/color/list',
                        show: hasPermission('view_color')
                    },
                    { 
                        name: 'Categorias', 
                        to: '/category/list',
                        show: hasPermission('view_category')
                    },
                    { 
                        name: 'Selos', 
                        to: '/tag/list',
                        show: hasPermission('view_tag')
                    },
                    { 
                        name: 'Gravações', 
                        to: '/customization/list',
                        show: hasPermission('view_customization')
                    },
                ],
            },
            { 
                name: 'Empresas', 
                svg: 'company', 
                to: '/company/list',
                show: true
            },
            { 
                name: 'Pessoas', 
                svg: 'people', 
                to: '/customer/list',
                show: hasPermission(['view_unrelated_customer', 'view_related_customer'])
            },
            { 
                name: 'Orçamentos', 
                svg: 'quote', 
                to: '/quote/list', 
                alert: quoteCount,
                show: hasPermission(['view_unrelated_budget', 'view_related_budget']),
            },
            { 
                name: 'Pedidos', 
                svg: 'order', 
                to: '/order/list',
                show: hasPermission(['view_unrelated_order', 'view_related_order'])
            },
            {
                name: 'Financeiro',
                svg: 'financial',
                show: true,
                subitems: [
                    { 
                        name: 'Fluxo de caixa', 
                        to: '/fluxo-de-caixa',
                        show: true
                    },
                    { 
                        name: 'Conciliação', 
                        to: '/conciliacao',
                        show: true
                    },
                    { 
                        name: 'Contas a pagar', 
                        to: '/contas-a-pagar',
                        show: true
                    },
                    { 
                        name: 'Contas a receber', 
                        to: '/contas-a-receber',
                        show: true
                    },
                    { 
                        name: 'Caixas e bancos', 
                        to: '/caixa/list',
                        show: true
                    },
                    { 
                        name: 'Prazos de pagamento', 
                        to: '/prazos-de-pagamento',
                        show: true
                    },
                    { 
                        name: 'Métodos de pagamento', 
                        to: '/metodos-de-pagamento',
                        show: true
                    }
                ]
            },
            {
                name: 'Relatórios',
                svg: 'graph',
                show: true,
                subitems: [
                    { 
                        name: 'Comercial', 
                        to: '/relatorio/comercial',
                        show: true
                    },
                    // { 
                    //     name: 'Compras', 
                    //     to: '/relatorio/compras',
                    //     show: true
                    // }
                ]
            },
            { 
                name: 'Notas fiscais', 
                svg: 'fiscal', 
                to: '/nf/list',
                show: true
            },
            { 
                name: 'Operações', 
                svg: 'truck', 
                to: '/logistics',
                show: hasPermission('view_logistics')
            },
            {
                name: 'Conteúdos',
                svg: 'design',
                show: hasPermission('content'),
                subitems: [
                    // { name: 'Dados de contato', to: '/data/edit' },
                    { 
                        name: 'Páginas',
                        to: '/page/list',
                        show: true
                    },
                    { 
                        name: 'Banners',
                        to: '/banner/list',
                        show: true
                    },
                    { 
                        name: 'Logos de clientes',
                        to: '/logo/list',
                        show: true
                    },
                    { 
                        name: 'Depoimentos de clientes',
                        to: '/testimonial/list',
                        show: true
                    },
                ]
            },
            { 
                name: 'Usuários', 
                svg: 'user',
                show: hasPermission(['admin', 'role']),
                subitems: [
                    { 
                        name: 'Usuários',
                        to: '/user/list',
                        show: hasPermission('admin')
                    },
                    { 
                        name: 'Níveis de acesso',
                        to: '/role/list',
                        show: hasPermission('role')
                    },
                ]
            },
            {
                name: 'Configurações',
                svg: 'config',
                show: hasPermission(['calculation', 'status', 'email_template']),
                subitems: [
                    { 
                        name: 'Site', 
                        to: '/variable/list',
                        show: hasPermission('site')
                    },
                    { 
                        name: 'Cálculo', 
                        to: '/calculation',
                        show: hasPermission('calculation')
                    },
                    { 
                        name: 'Categorias dos fornecedores', 
                        to: '/company/categories',
                        show: true
                    },
                    { 
                        name: 'Status', 
                        to: '/status/list',
                        show: hasPermission('status')
                    },
                    { 
                        name: 'Templates de e-mail', 
                        to: '/email-template/list',
                        show: hasPermission('email_template')
                    }
                ]
            },
        ];

        setItems(base);
    }

    
    return (
        <aside id="sidebar">
            <ul>
                {items.map((item, index) => {
                    if(item.show){
                        return (
                            <SidebarItem item={item} key={index} user={user} />
                        );
                    }
                })}
            </ul>
            <div id="user">
                <Link to="/">{user?.name}</Link>
                <Button type={`transparent`} svg={`logout`} action={signOut} />
            </div>
        </aside>
    );
}

export default Sidebar;